import { AxiosResponse } from "axios";
import config from "../../../../config/config";
import ApiClient from "../../../ApiClient/ApiClient";
import { IMappingMaterial, IMappingMaterialAddRequest, IMappingMaterialUpdateRequest } from "./types";
import fileDownload from "js-file-download";

const materialApi = new ApiClient("/Materials", config.api.baseUrl);

/**
 * Returns a list of all materials.
 */
export const getMaterialCatalogue = (): Promise<IMappingMaterial[]> => {
    return materialApi
        .get("/list", {
            clearCacheEntry: true,
        })
        .then((response: AxiosResponse<IMappingMaterial[]>) => {
            return Promise.resolve(response.data);
        });
};

/**
 * Create material into catalogue and return created entity.
 * @param data
 */
export const addMaterialCatalogue = (data: IMappingMaterialAddRequest): Promise<IMappingMaterial> => {
    return materialApi.post("/add", data).then((response: AxiosResponse<IMappingMaterial>) => {
        return Promise.resolve(response.data);
    });
};

/**
 * Update material in catalogue and return updated entity.
 * @param materialID
 * @param data
 */
export const updateMaterialCatalogue = (
    materialID: number,
    data: IMappingMaterialUpdateRequest
): Promise<IMappingMaterial> => {
    return materialApi.post(`/${materialID}/update`, data).then((response: AxiosResponse<IMappingMaterial>) => {
        return Promise.resolve(response.data);
    });
};

/**
 * Deletes material from catalogue.
 * @param materialID
 */
export const deleteMaterialCatalogue = (materialID: number): Promise<boolean> => {
    return materialApi.get(`/${materialID}/delete`).then((response: AxiosResponse<boolean>) => {
        return Promise.resolve(response.status === 204);
    });
};

/**
 * Export material, file is downloaded
 */
export const exportMaterial = (
): Promise<void> => {
    return materialApi
        .get(`/export`, {
            responseType: "blob"
        })
        .then((response) => {
            // Promise.resolve(response.data)
            fileDownload(response.data, "material.xlsx");
            return;
        });
};

/**
 * Import material, file is uploaded
 * @param data
 */
export const importMaterial = (
    data: FormData
): Promise<void> => {
    return materialApi
        .post(`/import`, data, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
        .then((response) => {
            return Promise.resolve(response.data)
        })
        .catch((response) => {
            return Promise.reject(response.response.data)
        })
        ;
};